import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["classes", "currentMonthIndex", "date", "locale", "showOtherMonths", "tileDisabled", "value", "activeStartDate"];
import React, { useContext } from 'react';
import Tile from '../tiles/Tile';
import { getBeginOfDay, getDay, getEndOfDay, isWeekend } from '../../utils/dates';
import { formatLongDate, formatWeekday } from '../../utils/dateFormatter';
import ClassNames from 'classnames';
import CalendarPickerContext from '../../context/CalendarPickerContext';
var Day = function Day(_ref) {
  var classes = _ref.classes,
    currentMonthIndex = _ref.currentMonthIndex,
    date = _ref.date,
    locale = _ref.locale,
    showOtherMonths = _ref.showOtherMonths,
    tileDisabled = _ref.tileDisabled,
    value = _ref.value,
    activeStartDate = _ref.activeStartDate,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useContext = useContext(CalendarPickerContext),
    dateValidator = _useContext.dateValidator,
    minDate = _useContext.minDate,
    maxDate = _useContext.maxDate,
    maxDetail = _useContext.maxDetail,
    disabledDays = _useContext.disabledDays,
    disabledDates = _useContext.disabledDates,
    disabledRanges = _useContext.disabledRanges,
    mergedDisabledDatesIntervals = _useContext.mergedDisabledDatesIntervals,
    momentUtils = _useContext.momentUtils;
  var isNeighboringMonth = date.getMonth() !== currentMonthIndex;
  var text = isNeighboringMonth && !showOtherMonths ? "" : getDay(date);
  var isInExcluded = momentUtils.isSame(value, date) && dateValidator.isDayExcluded(value, {
    disabledDates: disabledDates,
    disabledDays: disabledDays,
    disabledRanges: disabledRanges
  });
  var cn = ClassNames.apply(void 0, classes.concat(['ap-single-day', {
    "ap-single-day--weekend": isWeekend(date),
    "ap-single-day--neighboringMonth": isNeighboringMonth,
    "ap-single-day-init--excluded": isInExcluded
  }])).split(" ");
  var formatFullDate = function formatFullDate(locale, date) {
    return formatWeekday(locale, date) + ", " + formatLongDate(locale, date);
  };
  return /*#__PURE__*/React.createElement(Tile, _extends({}, otherProps, {
    classes: cn,
    date: date,
    formatAbbr: formatFullDate,
    maxDateTransform: getEndOfDay,
    minDateTransform: getBeginOfDay,
    view: "month",
    tileDisabled: isNeighboringMonth || tileDisabled,
    dateValidator: dateValidator,
    minDate: minDate,
    maxDate: maxDate,
    maxDetail: maxDetail,
    disabledDays: disabledDays,
    disabledDates: disabledDates,
    disabledRanges: disabledRanges,
    mergedDisabledDatesIntervals: mergedDisabledDatesIntervals
  }), text);
};
export default Day;